const getHeaders = (token) => {
    const headers = new Headers();
    headers.set('Content-Type', 'application/json');
    headers.append("Authorization", "Bearer " + token);
    return headers
}
export default getHeaders
